import React, { useState } from "react";
import { Box, Card, CardMedia, CardContent, Typography, Chip, CircularProgress, Button, IconButton, Snackbar, Alert } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export default function CampaignDetailsItemsList({
    items,
    hasMoreItems,
    isLoadingItems,
    isLoadingMore,
    totalItems,
    formatCurrency,
    getStatusColor,
    onLoadMore
}) {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [copiedText, setCopiedText] = useState('');

    const handleCopyMeliId = async (meliId) => {
        try {
            await navigator.clipboard.writeText(meliId);
            setCopiedText(meliId);
            setSnackbarOpen(true);
        } catch (err) {
            console.error('Erro ao copiar MELI_ID:', err);
        }
    };
    return (
        <Box sx={{ p: 2 }}>
            <Box sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: '1fr',
                    sm: 'repeat(2, 1fr)',
                    md: 'repeat(3, 1fr)',
                    lg: 'repeat(4, 1fr)'
                },
                gap: 3,
                mb: 3
            }}>                {items.map((item) => {
                const hasOriginalPrice = item.original_price && item.original_price > item.price;
                const discountPercent = hasOriginalPrice
                    ? Math.round(((item.original_price - item.price) / item.original_price) * 100)
                    : item.discount_amount || null;
                const imageUrl = item.images && item.images.filter(img => img.main)[0].thumbnailUrl;
                const cmvPrice = item.skus?.[0]?.price || item.skus?.price || item.cmv_price;
                return (
                    <Card
                        key={item.id || item.item_id}
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            borderRadius: 3,
                            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                            transition: 'all 0.3s ease',
                            border: '1px solid',
                            borderColor: 'grey.100',
                            overflow: 'hidden',
                            '&:hover': {
                                transform: 'translateY(-4px)',
                                boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                borderColor: 'primary.light',
                            }
                        }}
                    >
                        <Box sx={{
                            position: 'relative',
                            height: 200,
                            bgcolor: imageUrl ? 'transparent' : 'grey.50',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            {imageUrl ? (
                                <CardMedia
                                    component="img"
                                    height="200"
                                    image={imageUrl}
                                    alt={item.title || item.name || 'Item da campanha'}
                                    sx={{
                                        objectFit: 'contain',
                                        p: 1
                                    }}
                                />
                            ) : (
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    color: 'grey.400'
                                }}>
                                    <ShoppingCartIcon sx={{ fontSize: 48, mb: 1 }} />
                                    <Typography variant="caption" color="inherit">
                                        Sem imagem
                                    </Typography>
                                </Box>
                            )}                                {discountPercent && (
                                <Chip
                                    label={`${discountPercent}% OFF`}
                                    size="small"
                                    sx={{
                                        position: 'absolute',
                                        top: 12,
                                        right: 12,
                                        fontWeight: 700,
                                        fontSize: '0.75rem',
                                        height: 28,
                                        bgcolor: '#4caf50',
                                        color: 'white',
                                        '&:hover': {
                                            bgcolor: '#45a049'
                                        }
                                    }}
                                />
                            )}
                        </Box>
                        <CardContent sx={{
                            flexGrow: 1,
                            p: 3,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                        }}>
                            <Typography
                                variant="subtitle1"
                                component="div"
                                sx={{
                                    fontWeight: 600,
                                    height: '2.4em',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    lineHeight: 1.2,
                                    color: 'text.primary'
                                }}
                            >
                                {item.title || item.name || 'Sem título'}
                            </Typography>
                            <Box>                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Typography variant="body2" color="text.secondary">
                                    MELI_ID: {item.sku || item.item_id || item.id || 'N/A'}
                                </Typography>
                                {(item.sku || item.item_id || item.id) && (
                                    <IconButton
                                        size="small"
                                        onClick={() => handleCopyMeliId(item.sku || item.item_id || item.id)}
                                        sx={{
                                            p: 0.5,
                                            color: 'grey.500',
                                            '&:hover': {
                                                color: '#3483fa',
                                                bgcolor: 'rgba(52, 131, 250, 0.1)'
                                            }
                                        }}
                                    >
                                        <ContentCopyIcon sx={{ fontSize: 16 }} />
                                    </IconButton>
                                )}
                            </Box>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, flexWrap: 'wrap' }}>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            color: '#2e7d32',
                                            fontSize: '1.25rem'
                                        }}
                                    >
                                        {formatCurrency(item.price)}
                                    </Typography>
                                    {hasOriginalPrice && (
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{
                                                textDecoration: 'line-through',
                                                fontSize: '0.875rem'
                                            }}
                                        >
                                            {formatCurrency(item.original_price)}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                            <Box sx={{
                                mt: 'auto',
                                pt: 2,
                                borderTop: '1px solid',
                                borderColor: 'grey.100',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 1
                            }}>
                                {cmvPrice ? (
                                    <Chip
                                        label={`CMV: ${formatCurrency(cmvPrice)}`}
                                        size="small"
                                        sx={{
                                            bgcolor: 'grey.100',
                                            color: 'grey.700',
                                            fontWeight: 500,
                                            fontSize: '0.75rem'
                                        }}
                                    />
                                ) : <Box />}
                                <Chip
                                    label={item.status || 'Ativo'}
                                    size="small"
                                    color={getStatusColor(item.status)}
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: '0.75rem'
                                    }}
                                />
                            </Box>
                        </CardContent>
                    </Card>
                );
            })}
            </Box>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                p: 3,
                minHeight: '80px',
                borderTop: items.length > 0 ? '1px solid' : 'none',
                borderColor: 'grey.100',
                bgcolor: 'grey.25'
            }}>
                {hasMoreItems && !isLoadingItems && !isLoadingMore && (
                    <Button
                        variant="contained"
                        onClick={onLoadMore}
                        disabled={isLoadingItems || isLoadingMore}
                        sx={{
                            bgcolor: '#3483fa',
                            '&:hover': { bgcolor: '#2968c8' },
                            borderRadius: 3,
                            px: 6,
                            py: 1.5,
                            fontWeight: 600,
                            textTransform: 'none',
                            fontSize: '0.95rem',
                            boxShadow: '0 4px 12px rgba(52, 131, 250, 0.3)',
                            '&:hover': {
                                bgcolor: '#2968c8',
                                boxShadow: '0 6px 16px rgba(52, 131, 250, 0.4)',
                                transform: 'translateY(-1px)'
                            }
                        }}
                    >
                        Carregar mais itens
                    </Button>
                )}
                {(isLoadingItems || isLoadingMore) && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <CircularProgress size={28} sx={{ color: '#3483fa' }} />
                        <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 500 }}>
                            Carregando mais itens...
                        </Typography>
                    </Box>
                )}
            </Box>
            {!hasMoreItems && items.length > 0 && (
                <Box sx={{
                    textAlign: 'center',
                    mt: 2,
                    mb: 3,
                    p: 3,
                    bgcolor: 'success.50',
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'success.200'
                }}>
                    <Typography variant="body1" color="success.dark" sx={{ fontWeight: 600 }}>
                        ✨ Todos os {totalItems} itens foram carregados com sucesso!
                    </Typography>
                    <Typography variant="body2" color="success.dark" sx={{ mt: 0.5, opacity: 0.8 }}>
                        {`Você visualizou todos os itens disponíveis nesta campanha.`}
                    </Typography>
                </Box>
            )}            <Snackbar
                open={snackbarOpen}
                autoHideDuration={2000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity="success"
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    MELI_ID copiado: {copiedText}
                </Alert>
            </Snackbar>
        </Box>
    );
}
